import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson = () => {
  let initData: any = {
    table: "shop_order_det",
    list_id: "use_order_det_popup",
    x_column_list_arr: [
      { "key": "product_name", "name": "상품명", "width": "30", "is_show": "1" },
      { "key": "stu_name", "name": "사용자", "width": "20", "is_show": "1" },
      { "key": "online_sort", "name": "구분", "width": "10", "is_show": "1" },
      { "key": "use_sort", "name": "데일리플랜 교재", "width": "20", "is_show": "1" },
    ],
    list_opt_origin: {
      'now_page': 1,
      'num_per_page': 10,
      'order_id': '',
      'order_type': '',
      's_date_type': '',
      's_start_date': '',
      's_end_date': '',
      'sc': {},
      "is_add_idx_info": "1",
    },
    order_id_col_arr: [
      { "value": "", "text": "없음" },
    ]
  };
  initData.pri_col_arr = ["a_ymd", "a_seq"];
  const xColumnArr: any = XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;